var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        "send-company",
        {
          "has-company-select": _vm.showCompanySelect,
          "has-status": !!_vm.recognitionText,
        },
      ],
    },
    [
      _c("el-input", {
        ref: "transportInputRef",
        staticClass: "transport-input",
        attrs: {
          clearable: "",
          placeholder: "请输入物流单号",
          maxlength: "40",
        },
        on: {
          input: _vm.handleTransportNoInput,
          blur: _vm.handleTransportNoBlur,
        },
        model: {
          value: _vm.companyInfo.transportNo,
          callback: function ($$v) {
            _vm.$set(_vm.companyInfo, "transportNo", $$v)
          },
          expression: "companyInfo.transportNo",
        },
      }),
      _vm._v(" "),
      _vm.showCompanySelect
        ? _c(
            "el-select",
            {
              staticClass: "company-select",
              attrs: {
                filterable: "",
                placeholder: "请选择物流公司",
                clearable: "",
                "filter-method": _vm.handleAgreementSearch,
              },
              on: { change: _vm.changeSelect },
              model: {
                value: _vm.companyInfo.companyValue,
                callback: function ($$v) {
                  _vm.$set(_vm.companyInfo, "companyValue", $$v)
                },
                expression: "companyInfo.companyValue",
              },
            },
            _vm._l(_vm.companyOption, function (dict) {
              return _c("el-option", {
                key: dict.deliveryId,
                attrs: { label: dict.deliveryName, value: dict.deliveryId },
              })
            }),
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showCompany && _vm.recognitionText
        ? _c(
            "span",
            { class: ["recognition-text", "is-" + _vm.recognitionStatus] },
            [_vm._v("\n        " + _vm._s(_vm.recognitionText) + "\n    ")]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }